import {
  DYNAMIC_MODAL_ACTIONS,
  DYNAMIC_MODAL_VIEWS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { ErrorView } from '../ErrorView';

export const OfflineError = ({ onConfirm }: { onConfirm: () => void }) => {
  return (
    <ErrorView
      id="offline-error"
      dynamicModalView={DYNAMIC_MODAL_VIEWS.ModalNetwork}
      actionCallback={(action: DYNAMIC_MODAL_ACTIONS) => {
        switch (action) {
          case DYNAMIC_MODAL_ACTIONS.CLOSE:
            onConfirm();
            break;
          default:
            break;
        }
      }}
    />
  );
};
